export default __webpack_public_path__ + "static/media/MagnifyingGlass.b8530252.svg";